// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom"; // For scroll-to-top and route-based logic

// // Expanded services data with real images from Unsplash
// const servicesData = [
//   {
//     id: 1,
//     name: "Computer Sales",
//     description:
//       "High-quality desktops and laptops for personal and professional use.",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 2,
//     name: "Computer Accessories",
//     description: "Keyboards, mice, monitors, and other essential peripherals.",
//     image:
//       "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 3,
//     name: "Repairs & Maintenance",
//     description: "Expert repair and maintenance for all computer brands.",
//     image:
//       "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 4,
//     name: "Networking Solutions",
//     description: "Wired and wireless network setup and optimization.",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 5,
//     name: "Custom PC Builds",
//     description: "Tailored PC builds for gaming, work, or creative projects.",
//     image:
//       "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 6,
//     name: "Software Installation",
//     description: "Professional software setup and configuration services.",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 7,
//     name: "Data Recovery",
//     description: "Recover lost or corrupted data from hard drives and devices.",
//     image:
//       "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 8,
//     name: "Cloud Solutions",
//     description: "Cloud storage and computing solutions for businesses.",
//     image:
//       "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 9,
//     name: "Cybersecurity Services",
//     description: "Protect your systems with advanced security solutions.",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
//   {
//     id: 10,
//     name: "IT Consulting",
//     description: "Expert advice to optimize your IT infrastructure.",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//   },
// ];

// function AllServices() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const location = useLocation(); // Get current route

//   // Scroll to top when component mounts
//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to top-left of the page
//   }, [location.pathname]); // Trigger on route change

//   // Set document title
//   useEffect(() => {
//     document.title = "Our Services - Tech Solutions"; // Set page title
//   }, []);

//   // Filter services based on search term
//   const filteredServices = servicesData.filter((service) =>
//     service.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       {/* Header Section */}
//       <div className="text-center mb-8">
//         <h2 className="text-4xl font-bold text-gray-800 mb-2">Our Services</h2>
//         <p className="text-gray-600">
//           Explore our wide range of professional IT services tailored to your
//           needs.
//         </p>
//       </div>

//       {/* Search Bar */}
//       <div className="max-w-lg mx-auto mb-8">
//         <input
//           type="text"
//           placeholder="Search services..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//         />
//       </div>

//       {/* Services Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
//         {filteredServices.length > 0 ? (
//           filteredServices.map((service) => (
//             <div
//               key={service.id}
//               className="relative bg-white border rounded-lg shadow-md p-4 hover:shadow-xl transition-transform transform hover:-translate-y-1"
//             >
//               <img
//                 src={service.image}
//                 alt={service.name}
//                 className="w-full h-40 object-cover rounded-md mb-4"
//                 loading="lazy"
//               />
//               <h3 className="text-xl font-semibold text-gray-800 mb-2">
//                 {service.name}
//               </h3>
//               <p className="text-gray-600 text-sm">{service.description}</p>
//               {/* <button className="mt-4 text-blue-600 hover:text-blue-800 font-medium text-sm">
//                 Learn More
//               </button> */}
//             </div>
//           ))
//         ) : (
//           <p className="text-gray-500 col-span-full text-center">
//             No services found for "{searchTerm}".
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }

// export default AllServices;

// AllServices.tsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FaLaptop,
  FaNetworkWired,
  FaServer,
  FaCode,
  FaGlobe,
  FaClipboardList,
  FaPenFancy,
  FaPrint,
  FaSearch,
} from "react-icons/fa";

const kevmarkServices = [
  {
    id: 1,
    name: "Preventive Maintenance & Repair",
    description:
      "IT troubleshooting, diagnostics, and repair for laptops, desktops, printers, and more.",
    icon: <FaLaptop className="w-6 h-6 text-blue-600" />,
    img: "https://www.techly.com/media/catalog/product/2/0/20-56_2.jpg",
  },
  {
    id: 2,
    name: "Networking & Cabling",
    description:
      "Design, supply, and installation of LAN, power, voice, and data cabling systems.",
    icon: <FaNetworkWired className="w-6 h-6 text-indigo-600" />,
    img: "https://media.startech.com/cms/products/gallery_large/n6patch15bl10pk.main.jpg",
  },
  {
    id: 3,
    name: "Hardware Supply & Install",
    description:
      "Servers, desktops, printers, CCTV, UPS, access control systems – supply & setup.",
    icon: <FaServer className="w-6 h-6 text-teal-600" />,
    img: "https://www.rbs-usa.com/img/uploads/image/All-hardware.png",
  },
  {
    id: 4,
    name: "Software & Training",
    description:
      "Software supply, installation, integration, user training, and ongoing support.",
    icon: <FaCode className="w-6 h-6 text-green-600" />,
    img: "https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 5,
    name: "Website Design & Hosting",
    description:
      "Custom website design, domain registration, hosting, and maintenance.",
    icon: <FaGlobe className="w-6 h-6 text-purple-600" />,
    img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 6,
    name: "Stationery & Office Supplies",
    description:
      "Paper, inks, toners, pens, notebooks, filing – everything at great prices.",
    icon: <FaClipboardList className="w-6 h-6 text-orange-600" />,
    img: "https://m.media-amazon.com/images/I/81K5l37CaGL.jpg",
  },
  {
    id: 7,
    name: "Branding & Design",
    description:
      "Logo design, business cards, banners – custom branding for SMEs and corporates.",
    icon: <FaPenFancy className="w-6 h-6 text-pink-600" />,
    img: "https://media.licdn.com/dms/image/v2/D4E12AQE5h7fOUJoqnQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1690827620760?e=2147483647&t=-fWaTqvuEGfAllY3HAgLAEpPhjMWKH_zMLdps3IzZfM&v=beta",
  },
  {
    id: 8,
    name: "Industrial Printing",
    description:
      "Flyers, brochures, posters, books – e-commerce platform + 5% sponsor discount.",
    icon: <FaPrint className="w-6 h-6 text-red-600" />,
    img: "https://image.made-in-china.com/2f0j00odjthYMCySqO/3-2m-Advertisement-PVC-Banner-Large-Format-Printer.webp",
  },
];

function AllServices() {
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Set document title
  useEffect(() => {
    document.title = "All Services - KevMark Investments";
  }, []);

  // Filter services
  const filteredServices = kevmarkServices.filter(
    (service) =>
      service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      service.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-white via-gray-50 to-white overflow-hidden">
      {/* === SMOOTH BACKGROUND (Same as Products/Services) === */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-purple-50" />
        <div className="absolute top-10 left-10 w-96 h-96 bg-blue-300 rounded-full filter blur-3xl opacity-20 animate-pulse" />
        <div className="absolute top-32 right-20 w-80 h-80 bg-purple-300 rounded-full filter blur-3xl opacity-15 animate-pulse delay-700" />
        <div className="absolute bottom-20 left-32 w-72 h-72 bg-teal-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-1000" />
        <div className="absolute bottom-10 right-40 w-64 h-64 bg-pink-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-300" />
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-white to-transparent" />
      </div>

      {/* === CONTENT === */}
      <div className="relative z-10 py-16 px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            All Our Services
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            From ICT solutions to printing and branding — explore everything
            KevMark offers.
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto mb-12">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search services... (e.g. printing, repair, website)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-5 py-4 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition text-gray-700"
            />
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {filteredServices.length > 0 ? (
            filteredServices.map((service) => (
              <div
                key={service.id}
                className="group bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden border border-white/50"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.img}
                    alt={service.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    {service.icon}
                    <h3 className="text-xl font-semibold text-gray-800">
                      {service.name}
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 line-clamp-3">
                    {service.description}
                  </p>
                  {/* <button className="mt-4 w-full bg-blue-700 text-white py-2.5 rounded-lg font-medium hover:bg-blue-800 transition text-sm">
                    Get Quote
                  </button> */}
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-full text-center py-12">
              <p className="text-gray-500 text-lg">
                No services found for "
                <span className="font-medium">{searchTerm}</span>".
              </p>
              <p className="text-gray-400 mt-2">
                Try searching for "printing", "repair", or "website"
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AllServices;
